import React, { useState } from "react";
import { Checkbox, Form, message, Modal, Radio } from "antd";
import { useAppDispatch, useAppSelector } from "../../../store/reduxHooks";
import { SELECT_REFUSE_MODAL } from "../../../store/selectors/modalStatesSelector";
import { refuseVariantsArray } from "./config";
import { CLOSE_REFUSE_MODAL } from "../../../store/slices/modalStatesSlice/modalStatesSlice";
import { useRejectApplicationBankMutation } from "../../../store/api/applicationBankApi/applicationBank.api";
import TextArea from "antd/es/input/TextArea";
import classes from "./RefuseVariantsModal.module.css";
import { useForm } from "antd/es/form/Form";
interface RefuseVariantsModalProps {
  applicationBankId: number;
}

type FormFields = {
  textType: string;
  text: string;
};

export const RefuseVariantsModal = (props: RefuseVariantsModalProps) => {
  const { applicationBankId } = props;
  const dispatch = useAppDispatch();
  const modalState = useAppSelector(SELECT_REFUSE_MODAL);
  const [rejectApplication] = useRejectApplicationBankMutation();

  const [form] = useForm();

  const [isStandartRefuseType, setIsStandartRefuseType] = useState(true);

  const closeModal = () => {
    dispatch(CLOSE_REFUSE_MODAL());
  };

  const onFinish = (params: FormFields) => {
    if (form.getFieldValue(["text"]) === undefined) {
      message.error("Поле вашего ответа не может быть пустым");
      return;
    }
    rejectApplication({
      applicationBankId,
      rejectData: params,
    });
    closeModal();
  };

  const handleChangeRefuseType = () => {
    setIsStandartRefuseType(!isStandartRefuseType);
    form.resetFields(["text"]);
    const option = isStandartRefuseType ? "choice_option" : "text_option";
    form.setFieldValue(["textType"], option);
  };

  const onValuesChange = (changeValues: FormFields) => {
    const changedValue = Object.entries(changeValues);
    form.setFieldValue(["virtual_field"], {
      textType: changedValue[0][0],
      text: changedValue[0][1],
    });
  };

  const initialValues = {
    textType: "text_option",
  };

  return (
    <Modal
      width={"720px"}
      open={modalState}
      onCancel={() => closeModal()}
      onOk={() => form.submit()}
    >
      <h3 className={classes.titleContainer}>Укажите причину отказа</h3>
      <Form
        initialValues={initialValues}
        className={classes.modalContainer}
        form={form}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Form.Item name="text" className={classes.formItem}>
          <Radio.Group
            defaultValue={1}
            className={classes.standartVariantsContainer}
            disabled={!isStandartRefuseType}
          >
            {refuseVariantsArray.map((variant, index) => (
              <Radio
                className={classes.variantContainer}
                value={variant}
                key={index}
              >
                <span>{variant}</span>
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>

        <Form.Item name="textType" className={classes.formItem}>
          <Checkbox onChange={() => handleChangeRefuseType()}>
            Свой вариант
          </Checkbox>
        </Form.Item>
        {!isStandartRefuseType && (
          <Form.Item name="text" className={classes.formItem} required>
            <TextArea autoFocus />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};
